import { ContextStore, PageStore, ExperimentStore } from "bernie-plugin-mobx";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

// Holds all the current experiments running in Blossom. Update and clean this as needed.
export enum Experiment {
  Dateless_PDP_Customer_Survey_Qualtrics = "Dateless_PDP_Customer_Survey_Qualtrics", // 45074
  Qualtrics_Homepage_2021Q4 = "Qualtrics_Homepage_2021Q4",
  Qualtrics_Launchpage_2021Q4 = "Qualtrics_Launchpage_2021Q4",
  PWA_ESS_Feedback_Loop_Enable = "PWA_ESS_Feedback_Loop_Enable",
  Flex_HTG_Blossom_POSa_Redirect_Banner = "Flex_HTG_Blossom_POSa_Redirect_Banner",
  Flex_typeahead_in_wizard = "Flex_typeahead_in_wizard",
  Add_Distance_to_Nearest_Points_on_Hotel_cards = "Add_Distance_to_Nearest_Points_on_Hotel_cards", // 34305
  Flex_HFTG_Affinity_Reviews = "Flex_HFTG_Affinity_Reviews",
  Blossom_SRP_Lite_V2 = "Blossom_SRP_Lite_V2",
  MIT_PWASF_PKGFLEXIBILITY_FSSSE = "MIT_PWASF_PKGFLEXIBILITY_FSSSE",
  Blossom_Skip_Server_Fetch = "Blossom_Skip_Server_Fetch",
  Feature_Gate_MAB_on_SF = "Feature_Gate_MAB_on_SF",
  LP_SC_Covid19_TravelAdvisory_for_LandingPages = "LP_SC_Covid19_TravelAdvisory_for_LandingPages",
  LP_WIZARD_POPULAR_FILTERS_ON_HTG = "LP_WIZARD_POPULAR_FILTERS_ON_HTG",
  Chatbot_FAB_for_PWA = "Chatbot_FAB_for_PWA",
  VAC_PhaseOne = "VAC_PhaseOne",
  VAC_PhaseTwo = "VAC_PhaseTwo",
  VAC_PhaseThree = "VAC_PhaseThree",
  New_Package_Flight_Type_Multicity = "MIT_PWA_PKGFLEXIBILITY_MCITYPKG", // 35877
  New_Package_Flight_Type_Oneway = "MIT_PWA_PKGFLEXIBILITY_ONEWAYPKG", // 35880
  Surface_PWA_SF_Travel_Advisory_Chatbot = "Surface_PWA_SF_Travel_Advisory_Chatbot",
  Package_HC_Different_Pickup_Location = "MIT_PWA_FLEXIBLE_HC", // 37221
  Blossom_Mab_Wizard_Search_Button_Copy = "Blossom_Mab_Wizard_Search_Button_Copy", // 37516
  Flex_blossom_landing_page_chatbot = "Flex_blossom_landing_page_chatbot", // 38171
  Alignment_of_Traveler_Input = "Alignment_of_Traveler_Input", // 38265
  posa_switcher_sf_rollout = "posa_switcher_sf_rollout", // 38460
  PWA_PACKAGE_WIZARD_3PP_DEFAULT_TAB = "PWA_PACKAGE_WIZARD_3PP_DEFAULT_TAB", //39172
  SDUI_Trips_Total_Throttle = "SDUI_Trips_Total_Throttle", //39455
  PWA_Trips_Important_SF = "PWA_Trips_Important_SF", //39599
  Trips_PWA_SDUI_Rollout = "Trips_PWA_SDUI_Rollout", //39594
  LP_Immediate_Property_Filtering = "LP_Immediate_Property_Filtering", // 40648
  Blossom_Node_Streaming = "Blossom_Node_Streaming", // 40960
  Blossom_Dynamic_Render = "Blossom_Dynamic_Render", // 41029
  Cars_Lift30DaysRestrictionOnEMEA = "Cars_Lift30DaysRestrictionOnEMEA", // 41243
  MeSo_Marquee_Gallery_POC = "MeSo_Marquee_Gallery_POC", //38717
  ADF21 = "ADF21", // 41547,
  EXPEDIA_BRAND_REFRESH_JUNE = "EXPEDIA_BRAND_REFRESH_JUNE", // 41563,
  TSR_in_new_transportation_pwa = "TSR_in_new_transportation_pwa", // 42799,
  SPF21_V2 = "SPF21_V2", // 42254
  ILL21 = "ILL21", // 42232
  WIZARD_CLICKSTREAM = "WIZARD_CLICKSTREAM", // 42261
  GT_REMOVE_SAME_NEXT_DAY_SEARCH = "Remove_Same_Day_GT", //42516
  BEX_Typeahead_Alt_Destination_Web = "BEX_Typeahead_Alt_Destination_Web", //42607
  BEX_Homepage_Hero = "BEX_Homepage_Hero", // 42720
  GT_Round_Trip = "GT_Round_Trip", //42812
  EGTA_throttle_and_debounce = "EGTA_throttle_and_debounce", //42716
  BEX_Web_Use_Current_Location_onFocus = "BEX_Web_Use_Current_Location_onFocus", // 43015
  Use_Your_Current_Location_in_Typeahead_Cars_LOB = "Use_Your_Current_Location_in_Typeahead_Cars_LOB", // 43424
  BEX_Last_Search_Prefill_Lodging = "BEX_Last_Search_Prefill_Lodging", // 43497
  BEX_WEB_Typeahead_History_With_details = "BEX_WEB_Typeahead_History_With_details", // 43370"
  Cruise_Search_Results_PWA = "Cruise_Destination_Selection", // 42794
  TAAP_New_Shopping_Exp_Storefront_Tab = "TAAP_New_Shopping_Exp_Storefront_Tab", // 45100
  Remove_POI_and_Neighborhood_from_flight_and_package_typeahead = "Remove_POI_and_Neighborhood_from_flight_and_package_typeahead", //44133
  Delta_Enable_Discount_Code = "Delta_Enable_Discount_Code", //44590
  BEX_Property_Content_Reporting = "BEX_Property_Content_Reporting", // 44300
  gallery_images_ML_relevancy_score_sorting = "gallery_images_ML_relevancy_score_sorting", //44379
  E2E_Pricing_Claim_Member_Update_BEX = "E2E_Pricing_Claim_Member_Update_BEX", // 44754
  Sticky_Lodging_Search_Form = "Sticky_Lodging_Search_Form", // 45255
}

/**
 * Return bucket number of experiment.
 * @param {ExtendedContextStore} context - Store where the experiments array live
 * @param {string} experimentName - Experiment name used (check out link)
 * @returns {number} - Experiment Bucket
 */

export const getExperimentBucket = (context: ExtendedContextStore | undefined, experimentName: Experiment): number =>
  context?.experimentContext?.experiments?.[experimentName] || 0;

/**
 * Return bucket number of experiment from bernie experiments store.
 * @param {ExperimentStore} experiments - Instance of bernie experiment store
 * @param {string} experimentName - Experiment name used (check out link)
 * @returns {number} - Experiment Bucket
 */

export const getExperimentBucketFromExperimentsStore = (
  experiments: ExperimentStore | undefined,
  experimentName: Experiment
): number => experiments?.exposures?.[experimentName]?.bucket || 0;

/**
 * Checks if an experiment is in a given variant.
 * {@link https://tnl.prod.expedia.com}
 * @param {ExtendedContextStore} context - Store where the experiments array live
 * @param {string} experimentName - Experiment name used (check out link)
 * @param {number} value - Defaults to 1. Value that we are checking the experiment against
 * @returns {boolean} - True when the context contains an experiment string that matches a given numeric value
 */
export const isVariantEnabled = (
  context: ExtendedContextStore | undefined,
  experimentName: Experiment,
  value = 1
): boolean => getExperimentBucket(context, experimentName) === value;

/**
 * isVariantEnabledAndLog
 *
 * Checks whether an experiment is in a given bucket and logs the experiment.
 *
 * @param {string} experimentName Experiment name (programmatic, not friendly name)
 * @param {ContextStore} context ContextStore (Bernie), or ExtendedContextStore (Flex).
 * @param {ExperimentStore} experiment ExperimentStore (Bernie)
 * @param {PageStore} page PageStore (Bernie)
 * @param {number} bucket Value that we are checking the experiment against. Defaults to 1.
 *
 * @returns {boolean}
 */
export const isVariantEnabledAndLog = (
  experimentName: Experiment | string,
  context: ContextStore,
  experiment: ExperimentStore,
  page: PageStore,
  bucket = 1
): boolean => {
  const exposure = experiment.exposures?.[experimentName];

  if (!exposure) {
    return false;
  }

  experiment.logExperiment(context, page, exposure);

  return exposure.bucket === bucket;
};
